// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-card {
  display: block;
  padding: 17px 18px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-xs);
  text-decoration: none;
  transition: border-color 0.2s, box-shadow 0.2s, transform 0.15s;
}

.order-card:hover {
  border-color: var(--brand-300);
  box-shadow: var(--shadow-sm);
  transform: translateY(-2px);
}

.order-card-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 7px;
}

.order-card-top h3 {
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.35;
  color: var(--text);
}

.order-card-desc {
  margin-bottom: 11px;
  font-size: 0.88rem;
  line-height: 1.55;
  color: var(--muted);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.order-card-budget {
  font-family: var(--font-display);
  font-weight: 700;
  color: var(--brand);
}
`, "",{"version":3,"sources":["webpack://./src/app/components/OrderCard.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;EACrB,+DAA+D;AACjE;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".order-card {\n  display: block;\n  padding: 17px 18px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-xs);\n  text-decoration: none;\n  transition: border-color 0.2s, box-shadow 0.2s, transform 0.15s;\n}\n\n.order-card:hover {\n  border-color: var(--brand-300);\n  box-shadow: var(--shadow-sm);\n  transform: translateY(-2px);\n}\n\n.order-card-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 7px;\n}\n\n.order-card-top h3 {\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1.35;\n  color: var(--text);\n}\n\n.order-card-desc {\n  margin-bottom: 11px;\n  font-size: 0.88rem;\n  line-height: 1.55;\n  color: var(--muted);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.order-card-budget {\n  font-family: var(--font-display);\n  font-weight: 700;\n  color: var(--brand);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
